module.exports = __webpack_public_path__ + "img/zalo.a7eb9706.svg";